<div class="flex flex-col max-h-screen -m-6 overflow-hidden"  *transloco="let t">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ t('Select Location To Continue') }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    <div class="px-5 pt-5">
        <mat-form-field class="w-full">
            <mat-icon [svgIcon]="'heroicons_outline:search'" matPrefix></mat-icon>
            <input [placeholder]="t('Search Business By Name')" [(ngModel)]="locationName" matInput
                   (keyup)="searchLocation()">
            <mat-icon [svgIcon]="'heroicons_outline:x-circle'" class="cursor-pointer" matSuffix
                      (click)="clearSearchText()"></mat-icon>
        </mat-form-field>
    </div>

    <div class="flex flex-col h-140 md:max-h-140 overflow-auto space-y-2 p-5 pt-0">
        <div *ngFor="let location of allLocations;" (click)="setLocation(location)"
             class="flex items-center hover:bg-gray-100 w-full p-2 hover:cursor-pointer border shadow-sm h-auto rounded-2xl md:w-160">
            <img *ngIf="hasLocationLogo(location)" [alt]="t('Logo')" [src]="location.logoURL"
                 (error)="onLogoError(location.locationId)"
                 class="w-10 h-10 min-w-10 min-h-10 rounded-full object-cover shrink-0">
            <div *ngIf="!hasLocationLogo(location)"
                 class="w-10 h-10 min-w-10 min-h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-base uppercase shrink-0">
                {{ getLocationInitial(location) }}
            </div>
            <div class="ml-2">
                <h1 class="font-semibold leading-tight">{{ location.name }}</h1>
                <span class="text-md leading-tight text-slate-500">{{ location.address }}</span>
            </div>
        </div>
    </div>
    <div class="w-full">
        <mat-paginator (page)="getNextLocations($event)" [length]="allLocationPageable?.totalElements"
                       [hidePageSize]="!allLocationPageable?.size" [pageIndex]="allLocationPageable?.number"
                       [pageSize]="allLocationPageable?.size" class="flex justify-center md:justify-end h-10">
        </mat-paginator>
    </div>
</div>
